import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, PlusIcon } from "lucide-react";
import { media } from "../../data/media";
import { products } from "../../data/products";
import type { Product } from "../../types/product";
import { useCart } from "../../contexts/CartContext";
import { formatPrice, shopifyImg } from "../../utils/format";
import { btnSecondary, container } from "../../utils/styles";
const lampIds = ["koraal", "dune", "bloom", "tide"];
export function ShopTheLook() {
  const {
    add
  } = useCart();
  const lamps = lampIds.map(id => products.find(p => p.id === id)).filter((p): p is Product => Boolean(p));
  return <section aria-labelledby="look-heading" className="bg-sand py-16 lg:py-24" data-id="element-194" data-mp="3n6k3z4fdes18">
      <div className={`${container} grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-20`} data-id="element-195" data-mp="3i54l9j0o0xm0">
        <div className="overflow-hidden rounded-xl" data-id="element-196" data-mp="2bqvi6gdurz20">
          <img src={media.lampMood} alt="Slaapkamer in de avond met een warm brandende sculpturale lamp" loading="lazy" className="aspect-[4/5] w-full object-cover" data-id="element-197" data-mp="26pobylrcz7xg" />
        </div>

        <div data-id="element-198" data-mp="1ehmh3c0jzh3z">
          <h2 id="look-heading" className="text-3xl font-medium tracking-[-0.03em] text-ink lg:text-5xl lg:leading-[1.05]" data-id="element-199" data-mp="1ehctfv2zdm1g">
            Warm licht voor lange avonden
          </h2>
          <p className="mt-4 max-w-md text-[16px] leading-relaxed text-ink/70" data-id="element-200" data-mp="15gy32hb5tgr3">
            Onze lampen geven zacht, gelaagd licht. Kies een warm-witte LED van 2200–2700K voor het mooiste reliëf.
          </p>

          <ul className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-201" data-mp="viibkd8805h2">
            {lamps.map(p => {
            const needsChoice = Boolean(p.colors && p.colors.length > 1);
            return <li key={p.id} className="flex items-center gap-4 py-4" data-id="element-202" data-mp="mpx3br27th6h">
                  <Link to={`/product/${p.id}`} className="shrink-0" data-id="element-203" data-mp="7t63xhsjk5gv">
                    <img src={shopifyImg(p.image, 200)} alt="" className="h-16 w-16 rounded-lg bg-paper object-cover" data-id="element-204" data-mp="7txz4ri8816m" />
                  </Link>
                  <Link to={`/product/${p.id}`} className="min-w-0 flex-1" data-id="element-205" data-mp="3ptjuato3gdmj">
                    <span className="block text-[15px] font-medium text-ink hover:underline hover:underline-offset-4" data-id="element-206" data-mp="3puuukjibz38w">{p.name}</span>
                    <span className="block truncate text-sm text-muted" data-id="element-207" data-mp="3g2fghxa5myta">{p.colors && p.colors.length > 1 ? `${p.colors.length} kleuren` : p.type}</span>
                  </Link>
                  <span className="text-[15px] text-ink" data-id="element-208" data-mp="cmi6bobztquy">{formatPrice(p.price)}</span>
                  {needsChoice ? <Link to={`/product/${p.id}`} aria-label={`Kies kleur voor ${p.name}`} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-paper text-ink transition-colors duration-150 hover:bg-ink hover:text-paper" data-id="element-209" data-mp="7n5gqvtqm5oo">
                      <ArrowRightIcon className="h-4 w-4" data-id="element-210" data-mp="3twpylvrnbuqd" />
                    </Link> : <button type="button" onClick={() => add(p)} aria-label={`${p.name} in winkelwagen`} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-paper text-ink transition-colors duration-150 hover:bg-ink hover:text-paper" data-id="element-211" data-mp="2nc6vlxo8i0b0">
                      <PlusIcon className="h-4 w-4" data-id="element-212" data-mp="12xac35k0q5d2" />
                    </button>}
                </li>;
          })}
          </ul>

          <Link to="/shop?categorie=Verlichting" className={`${btnSecondary} mt-8 bg-transparent`} data-id="element-213" data-mp="1cmu0eqqi2rfb">
            Alle verlichting
          </Link>
        </div>
      </div>
    </section>;
}